import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { Auth } from 'src/app/domains/auth';
import { AccessDenied } from './domains/access-denied/pages/access-denied/access-denied';
import { MenuItemConstants, RoleConstants, RouteConstants } from './models';
import { MenuItem } from './models/menu/menu.models';

export const routes: Routes = [
  {
    path: RouteConstants.ADMIN,
    loadChildren: () => import('./domains/admins/admins.routes').then(m => m.ADMINS_ROUTES),
    canActivate: [MsalGuard],
  },
  {
    path: RouteConstants.CONTRIBUTOR,
    loadChildren: () => import('./domains/contributors/contributors.routes').then(m => m.CONTRIBUTORS_ROUTES),
    canActivate: [MsalGuard],
  },
  {
    path: RouteConstants.READER,
    loadChildren: () => import('./domains/readers/readers.routes').then(m =>  m.READERS_ROUTES),
    canActivate: [MsalGuard],
  },
  {
    path: RouteConstants.DOCUMENTS,
    loadChildren: () => import('./domains/documents/documents.routes').then(m =>  m.DOCUMENTS_ROUTES),
    canActivate: [MsalGuard],
  },
  {
    path: RouteConstants.SALES,
    loadChildren: () => import('./domains/sales/sales.routes').then(m =>  m.SALES_ROUTES),
    canActivate: [MsalGuard],
  },
  {
    path: 'access-denied',
    component: AccessDenied
  },
  {
    path: '',
    loadChildren: () =>  import('./domains/home/home.routes').then(m => m.HOME_ROUTES),
    canActivate: [MsalGuard]
  },
  {
    path: 'login-failed',
    component: Auth
  },
  {
    path: '**', 
    redirectTo: '', 
    pathMatch: 'full'
  } 
];

export const menuItems : MenuItem[] = [
  { 
    name: MenuItemConstants.HOME, 
    route: RouteConstants.HOME, 
    icon: '', 
    active: true, 
    allowedRoles: [] 
  },
  { 
    name: MenuItemConstants.DOCUMENTS, 
    route: RouteConstants.DOCUMENTS, 
    icon: '', 
    active: true, 
    allowedRoles: [
      RoleConstants.READER,
      RoleConstants.ADMIN,
    ],
    subItems:[
      {
        name: MenuItemConstants.NEW_DOCUMENT, 
        route: `${RouteConstants.DOCUMENTS}/${RouteConstants.NEW_DOCUMENT}`, 
        icon: '', 
        active: true, 
        allowedRoles: [
          RoleConstants.ADMIN
        ]
      }
    ]
  },
  { 
    name: MenuItemConstants.ADMIN, 
    route: RouteConstants.ADMIN, 
    icon: '', 
    active: true, 
    allowedRoles: [
      RoleConstants.ADMIN
    ] 
  },
  { 
    name: MenuItemConstants.SALES, 
    route: RouteConstants.SALES, 
    icon: '', 
    active: true, 
    allowedRoles: [
      RoleConstants.READER
    ],
    subItems:[
      {
        name: MenuItemConstants.SALES_REPORTS, 
        route: `${RouteConstants.SALES}/${RouteConstants.SALES_REPORTS}`, 
        icon: '', 
        active: true, 
        allowedRoles: [
          RoleConstants.READER
        ]
      },
      {
        name: MenuItemConstants.NEW_SALE, 
        route: `${RouteConstants.SALES}/${RouteConstants.NEW_SALE}`, 
        icon: '', 
        active: true, 
        allowedRoles: [
          RoleConstants.ADMIN
        ]
      }
    ]
  },
  { 
    name: MenuItemConstants.READER, 
    route: RouteConstants.READER, 
    icon: '', 
    active: true, 
    allowedRoles: [
      RoleConstants.READER
    ],
    subItems:[
      {
        name: MenuItemConstants.READER_CHILD, 
        route: `${RouteConstants.READER}/${RouteConstants.READER_CHILD}`, 
        icon: '', 
        active: true, 
        allowedRoles: [
          RoleConstants.READER
        ]
      }
    ] 
  },
  { 
    name: MenuItemConstants.CONTRIBUTOR, 
    route: RouteConstants.CONTRIBUTOR, 
    icon: '', 
    active: true, 
    allowedRoles: [
      RoleConstants.CONTRIBUTOR
    ] 
  },
]